const ShopReturnMobileIconMenu = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        width="32"
        height="32"
        rx="6.64935"
        fill="url(#paint0_linear_2692_11586)"
        fill-opacity="0.1"
      />
      <path
        d="M22.6111 19.5H20.6667V22.125L19.8889 21.5426L19.1111 22.125V19.5H17.1667C16.9528 19.5 16.7778 19.6969 16.7778 19.9375V25.1875C16.7778 25.4281 16.9528 25.625 17.1667 25.625H22.6111C22.825 25.625 23 25.4281 23 25.1875V19.9375C23 19.6969 22.825 19.5 22.6111 19.5ZM13.2778 17.75H18.7222C18.9361 17.75 19.1111 17.5531 19.1111 17.3125V12.0625C19.1111 11.8219 18.9361 11.625 18.7222 11.625H16.7778V14.25L16 13.6676L15.2222 14.25V11.625H13.2778C13.0639 11.625 12.8889 11.8219 12.8889 12.0625V17.3125C12.8889 17.5531 13.0639 17.75 13.2778 17.75ZM14.8333 19.5H12.8889V22.125L12.1111 21.5426L11.3333 22.125V19.5H9.38889C9.175 19.5 9 19.6969 9 19.9375V25.1875C9 25.4281 9.175 25.625 9.38889 25.625H14.8333C15.0472 25.625 15.2222 25.4281 15.2222 25.1875V19.9375C15.2222 19.6969 15.0472 19.5 14.8333 19.5Z"
        fill="#052351"
      />
      <path
        d="M21.1845 22.9045C25.0762 21.6128 27.2541 17.6219 26.2245 13.77C25.2354 10.0672 21.7874 7.97405 18.5189 8.09328C18.5189 8.44435 18.5189 8.79542 18.5189 9.18293C17.2487 8.56027 16.0192 7.9608 14.7524 7.34146C16.0158 6.72212 17.2487 6.11934 18.5155 5.5C18.5155 5.8875 18.5155 6.23526 18.5155 6.59627C21.408 6.62939 23.7688 7.7124 25.5233 9.95462C26.7765 11.5609 27.332 13.4057 27.2135 15.4227C26.9764 19.4998 23.9111 22.1957 21.1845 22.9045Z"
        fill="#052351"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2692_11586"
          x1="15.7922"
          y1="0"
          x2="15.7922"
          y2="32"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0062FF" />
          <stop offset="1" stop-color="#004BC2" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default ShopReturnMobileIconMenu
